interface AgentDetailFieldsProps {
  toolCommand: string
  cloneBranch: string
  prompt: string
  editing: boolean
  editForm: { tool_command: string; clone_branch: string; prompt: string }
  onEditFormChange: (updates: Partial<{ tool_command: string; clone_branch: string; prompt: string }>) => void
}

function AgentDetailFields({ toolCommand, cloneBranch, prompt, editing, editForm, onEditFormChange }: AgentDetailFieldsProps) {
  return (
    <>
      <section className="agent-detail-section">
        <h2 className="agent-detail-section-title">Tool Command</h2>
        {editing ? (
          <input
            data-testid="agent-detail-tool-command-input"
            className="agent-detail-field-input"
            value={editForm.tool_command}
            onChange={(e) => onEditFormChange({ tool_command: e.target.value })}
          />
        ) : (
          <code data-testid="agent-detail-tool-command" className="agent-detail-code">{toolCommand}</code>
        )}
      </section>

      <section className="agent-detail-section">
        <h2 className="agent-detail-section-title">Clone Branch</h2>
        {editing ? (
          <input
            data-testid="agent-detail-clone-branch-input"
            className="agent-detail-field-input"
            value={editForm.clone_branch}
            onChange={(e) => onEditFormChange({ clone_branch: e.target.value })}
          />
        ) : (
          <code data-testid="agent-detail-clone-branch" className="agent-detail-code">{cloneBranch}</code>
        )}
      </section>

      <section className="agent-detail-section">
        <h2 className="agent-detail-section-title">Prompt / Instructions</h2>
        {editing ? (
          <textarea
            data-testid="agent-detail-prompt-input"
            className="agent-detail-textarea"
            value={editForm.prompt}
            onChange={(e) => onEditFormChange({ prompt: e.target.value })}
            rows={6}
          />
        ) : (
          <pre data-testid="agent-detail-prompt" className="agent-detail-pre">{prompt || '—'}</pre>
        )}
      </section>

    </>
  )
}

export default AgentDetailFields
